/**
 * @generated SignedSource<<1d2df3c28451c83e0bdbd2214f2a95b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserNodeIdTypeEnum = "DATABASE_ID" | "EMAIL" | "ID" | "SLUG" | "URI" | "USERNAME";
export type User_Search_Exists_Query$variables = {
  id: string;
  idType?: UserNodeIdTypeEnum | null | undefined;
};
export type User_Search_Exists_Query$data = {
  readonly user: {
    readonly id: string;
  } | null | undefined;
};
export type User_Search_Exists_Query = {
  response: User_Search_Exists_Query$data;
  variables: User_Search_Exists_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": "ID",
    "kind": "LocalArgument",
    "name": "idType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "idType",
        "variableName": "idType"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "User_Search_Exists_Query",
    "selections": (v1/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "User_Search_Exists_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c70fbd428791fdbe6a01ecc0c425df19",
    "id": null,
    "metadata": {},
    "name": "User_Search_Exists_Query",
    "operationKind": "query",
    "text": "query User_Search_Exists_Query(\n  $id: ID!\n  $idType: UserNodeIdTypeEnum = ID\n) {\n  user(id: $id, idType: $idType) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "723254881c3d0709eff745d04e15c1f0";

export default node;
